import { Image, Text, View } from '@react-pdf/renderer';
import ErrorPdfPage from '../chartPage/error';

export interface IPdfChart {
  title: string;
  image: string;
}

export const PdfChart = ({ title, image }: IPdfChart) => {
  const formulas: { [key: string]: any } = {
    'YoY ARR Growth': 'Year 2 ARR / Year 1 ARR - 1',
    'Net Dollar Retention':
      '1 + [(Net New ARR - New Logo ARR) / AVERAGE(BOP ARR, EOP ARR)]',
    'Gross Dollar Retention':
      '1 + [(Gross Churn ARR) / AVERAGE(BOP ARR, EOP ARR)]',
    'Net Magic Number': 'Net New ARR / S&M Expense',
    'Gross Margin': 'Gross Profit / Revenue',
    'Rule of 40': 'ARR Growth YoY % + FCF Margin %',
    'Burn Multiple': 'Net Burn / Net New ARR',
    'ARR per FTE': 'ARR / Total Headcount',
    'OpEx as a % of Revenue': 'Median OpEx by Function / Revenue',
    'FCF Margin': 'FCF / Revenue',
    'Quick Ratio': 'Gross New ARR / Gross Churned ARR',
    'Headcount Distribution':
      'Average Headcount by Function / Total Company Headcount (excluding Cost of Revenue FTEs)',
    'Gross New ARR Composition':
      'ARR New Logo: New Logo ARR / Gross New ARR\nARR Expansion: Expansion ARR / Gross New ARR',
    'New Logo Velocity': '[New Logo ARR t=0 / New Logo ARR t-1] -1',
    'CAC Payback': 'CAC / (ARR Per Customer & Gross Margin)',
    'OpEx per FTE': 'Total OpEx / Total Employees'
  };

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        height: '60%',
        marginHorizontal: '20px',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #F2F2F2'
      }}
    >
      <Text
        style={{ fontSize: '16px', fontWeight: 'semibold', color: '#151515' }}
      >
        {title}
      </Text>

      <Text style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}>
        {formulas[title]}
      </Text>

      <View style={{ flex: 1, marginTop: '-4px' }}>
        {image ? (
          <Image
            src={image}
            style={{ width: '100%', height: '100%', objectFit: 'scale-down' }}
          />
        ) : (
          <ErrorPdfPage />
        )}
      </View>
    </View>
  );
};
